"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProxy = exports.target = exports.record = exports.unwatch = exports.watch = void 0;
const watch_1 = require("./watch");
exports.watch = watch_1.default;
const unwatch_1 = require("./unwatch");
exports.unwatch = unwatch_1.default;
const record_1 = require("./record");
exports.record = record_1.default;
const target_1 = require("./target");
exports.target = target_1.default;
const is_proxy_1 = require("./is_proxy");
exports.isProxy = is_proxy_1.default;
